import { render } from "./DialogOptionsConfirm.vue?vue&type=template&id=1663a2d9&ts=true"
import script from "./DialogOptionsConfirm.vue?vue&type=script&lang=ts"
export * from "./DialogOptionsConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__